export default "__VITE_ASSET__BTZDqSku__"